import React from 'react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
export const FinalCTASection: React.FC = () => {
  return <section className="w-full bg-gradient-to-b from-[#00c853]/30 to-[#00c853]/10 py-24 relative" data-id="element-586">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-587" />
      <Container className="relative" data-id="element-588">
        <div className="text-center max-w-3xl mx-auto" data-id="element-589">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-10" data-id="element-590">
            Ready to See More Deals, Close Faster, and Save Thousands in Fees?
          </h2>
          <Button variant="primary" size="lg" href="https://form.typeform.com/to/ePFsBam5" data-id="element-591">
            Click here to schedule a call
          </Button>
        </div>
      </Container>
    </section>;
};